import { gsap } from "gsap";

class Header {
	constructor() {
		this.burgerButton = document.getElementById("burger-button");
		this.burgerButtonLines = document.querySelectorAll(".burger-button span");
		this.mainMenuWrapper = document.querySelector(".main-menu-wrapper");
		this.mainMenuItems = this.mainMenuWrapper.querySelectorAll(
			".nav-primary .menu-item"
		);
		this.mainMenuLinks = document.querySelectorAll(".main-menu-nav li a");
		this.itemsOnTheRight = this.mainMenuWrapper.querySelectorAll(
			".items-on-the-right > *"
		);
		this.allVh = document.querySelectorAll(".vh-fix");

		this.isWorking = false;
		this.isMenuOpen = false;
		this.init();
		this.events();
	}

	init() {
		// console.log(this.itemsOnTheRight)
	}

	menuLinkClicked() {
		this.burgerButton.dispatchEvent(new Event("click"));
		return false;
	}

	openMainMenu() {
		if (this.isMenuOpen) return false;
		// let menuItems;
		// menuItems = this.mainMenuWrapper.querySelectorAll('.nav-primary .menu-item')

		gsap.set(this.mainMenuItems, { y: "-20px", opacity: 0 });
		gsap.set(this.itemsOnTheRight, { y: "-20px", opacity: 0 });

		document.body.classList.add("is-menu-open");
		const menuTl = new gsap.timeline({
			onComplete: () => {
				this.isWorking = false;
				this.isMenuOpen = !this.isMenuOpen;
			},
		});
		const linesTl1 = new gsap.timeline();
		const linesTl2 = new gsap.timeline();
		linesTl1.to(this.burgerButtonLines[0], {
			duration: 0.2,
			y: 7,
			ease: "expo.inOut",
		});
		linesTl1.to(this.burgerButtonLines[0], {
			duration: 0.3,
			rotate: "-45deg",
			ease: "expo.inOut",
		});
		// gsap.to(this.burgerButtonLines[1], {
		// 	duration: 0.2,
		// 	opacity: 0,
		// 	ease: 'expo.inOut',
		// })
		linesTl2.to(this.burgerButtonLines[1], {
			duration: 0.2,
			y: -7,
			ease: "expo.inOut",
		});
		linesTl2.to(this.burgerButtonLines[1], {
			duration: 0.3,
			rotate: "45deg",
			ease: "expo.inOut",
		});
		menuTl.to(this.mainMenuWrapper, {
			duration: 0.7,
			y: 0,
			ease: "power3.Out",
		});
		menuTl.to(
			this.mainMenuItems,
			{
				duration: 0.2,
				y: 0,
				opacity: 1,
				stagger: 0.15,
			},
			"-=.5"
		);
		menuTl.to(this.itemsOnTheRight, {
			duration: 0.2,
			y: 0,
			opacity: 1,
			stagger: 0,
		});
		// tl.fromTo(menuItems, { y: '-20px', opacity: 0 }, {
		//   duration: .1, y: 0, opacity: 1, stagger: .1
		// }, "-=.25")
	}

	closeMainMenu() {
		if (!this.isMenuOpen) return false;

		const linesTl1 = new gsap.timeline();
		const linesTl2 = new gsap.timeline();

		document.body.classList.remove("is-menu-open");
		const menuTl = new gsap.timeline({
			onComplete: () => {
				// gsap.to(this.burgerButtonLines[1], {
				// 	duration: 0.2,
				// 	opacity: 1,
				// 	scale: 1,
				// 	ease: 'expo.inOut',
				// })
				this.isWorking = false;
				this.isMenuOpen = !this.isMenuOpen;
			},
		});
		linesTl1.to(this.burgerButtonLines[0], {
			duration: 0.3,
			rotate: 0,
			ease: "expo.inOut",
		});
		linesTl1.to(this.burgerButtonLines[0], {
			duration: 0.2,
			y: 0,
			ease: "expo.inOut",
		});
		linesTl2.to(this.burgerButtonLines[1], {
			duration: 0.3,
			rotate: 0,
			ease: "expo.inOut",
		});
		linesTl2.to(this.burgerButtonLines[1], {
			duration: 0.2,
			y: 0,
			ease: "expo.inOut",
		});
		menuTl.to(this.mainMenuWrapper, {
			duration: 0.6,
			y: "-100%",
			ease: "power3.in",
		});
	}

	onBurgerButtonClick() {
		if (this.isWorking) return false;
		this.isWorking = true;

		if (!this.isMenuOpen) {
			this.openMainMenu();
		} else {
			this.closeMainMenu();
		}
	}

	// onBurgerButtonMouseEnter() {
	// 	if (this.isWorking) return false
	// 	this.isWorking = true
	// 	this.burgerButton.classList.add('active')
	// 	gsap.to(this.burgerButtonLines[1], { duration: 0.2, scaleX: 0.8 })
	// 	this.isWorking = false
	// }

	// onBurgerButtonMouseLeave() {
	// 	if (this.isWorking) return false
	// 	this.isWorking = true
	// 	this.burgerButton.classList.remove('active')
	// 	gsap.to(this.burgerButtonLines[1], { duration: 0.2, scaleX: 1 })
	// 	this.isWorking = false
	// }

	onEscKeyPressed(ev) {
		if (!document.body.classList.contains("is-menu-open")) return false;

		let isEscape = false;
		if ("key" in ev) {
			isEscape = ev.key === "Escape" || ev.key === "Esc";
		} else {
			isEscape = ev.keyCode === 27;
		}

		if (isEscape) {
			this.burgerButton.dispatchEvent(new Event("click"));
		}
	}

	fixVh() {
		let vh = window.innerHeight * 0.01;
		if (this.allVh) {
			this.allVh.forEach((el) => {
				el.style.setProperty("--vh", `${vh}px`);
			});
		}
	}

	events() {
		this.burgerButton.addEventListener(
			"click",
			this.onBurgerButtonClick.bind(this),
			false
		);
		// this.burgerButton.addEventListener(
		// 	'mouseenter',
		// 	this.onBurgerButtonMouseEnter.bind(this),
		// 	false
		// )
		// this.burgerButton.addEventListener(
		// 	'mouseleave',
		// 	this.onBurgerButtonMouseLeave.bind(this),
		// 	false
		// )

		document.addEventListener(
			"keydown",
			this.onEscKeyPressed.bind(this),
			false
		);
		window.addEventListener("resize", this.fixVh.bind(this), false);
		window.addEventListener("resize", this.closeMainMenu.bind(this), false);

		this.mainMenuLinks.forEach((a) => {
			a.addEventListener("click", this.menuLinkClicked.bind(this), false);
		});
	}

	beforeUpdate(from, trigger, location) {
		// console.log('from:', from)
	}

	update(to) {
		if (this.mainMenuLinks.length) {
			this.mainMenuLinks.forEach((a) => {
				if (a.href === location.href)
					a.parentElement.classList.add("current-menu-item");
				else a.parentElement.classList.remove("current-menu-item");
			});
		}
	}

	destroy() {
		this.burgerButton.removeEventListener(
			"click",
			this.onBurgerButtonClick.bind(this),
			false
		);
		// this.burgerButton.removeEventListener(
		// 	'mouseenter',
		// 	this.onBurgerButtonMouseEnter.bind(this),
		// 	false
		// )
		// this.burgerButton.removeEventListener(
		// 	'mouseleave',
		// 	this.onBurgerButtonMouseLeave.bind(this),
		// 	false
		// )

		window.removeEventListener("resize", this.fixVh.bind(this), false);
		window.removeEventListener("resize", this.closeMainMenu.bind(this), false);

		document.removeEventListener(
			"keydown",
			this.onEscKeyPressed.bind(this),
			false
		);

		this.mainMenuLinks.forEach((a) => {
			a.removeEventListener("click", this.menuLinkClicked.bind(this), false);
		});
	}
}

export default Header;
